export default __webpack_public_path__ + "static/media/icon.38b81b1c.svg";